import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "bg-constructor-walls" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 512 512" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "m256 266l-160 162 0-60 160-159 160 160 0 59z" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "bg-constructor-walls__list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 512 512" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "m256 266l-160 162 0-60 160-159 160 160 0 59z" })
], -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "bg-constructor-walls__arrow-top",
      onClick: _cache[0] || (_cache[0] = () => _ctx.selectPreviousWall())
    }, _hoisted_3),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.walls, (wall) => {
        return (_openBlock(), _createElementBlock("li", {
          key: wall.id,
          style: _normalizeStyle({ 'background-image': 'url(' + wall.thumbnail_url + ')' }),
          onClick: ($event: any) => (_ctx.selectWall(wall)),
          class: _normalizeClass([_ctx.state.selectedWall === wall ? 'bg-constructor-walls__selected' : ''])
        }, null, 14, _hoisted_5))
      }), 128))
    ]),
    _createElementVNode("a", {
      class: "bg-constructor-walls__arrow-bottom",
      onClick: _cache[1] || (_cache[1] = () => _ctx.selectNextWall())
    }, _hoisted_7)
  ]))
}